import React from "react";
import back from "../../assets/service-images/service-now-back.webp";
import { Link } from "react-router-dom";
import image from "../../assets/service-images/leftimg-service.webp";
import image1 from "../../assets/service-images/Line001.png";
import tick from "../../assets/service-images/tick.png";

const TechnicalConsultation = () => {
  return (
    <>
      {/* Section 1 */}
      <div
        className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-start px-6 py-16 md:px-8 lg:px-16"
        style={{ backgroundImage: `url(${back})` }}
      >
        <h1
          data-aos="fade-down"
          className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-bold text-white w-full md:w-2/3 lg:w-1/2"
        >
          Get Back to the Usual
        </h1>
        <p
          data-aos="fade-down"
          className="text-white text-sm w-full md:w-2/3 lg:w-[500px] xl:w-[500px]"
        >
          Simplify your ServiceNow legacy challenges and ensure a flexible,
          efficient, and up-to-date platform that adapts to your evolving
          business needs.
        </p>
        <Link
          data-aos="zoom-in"
          data-aos-delay="300"
          to="/contact-us"
          className="w-[100px] sm:w-[120px] md:w-[140px] lg:w-[160px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white font-semibold hover:bg-white hover:text-[#C32A7C] transition-colors duration-300 text-xs sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
        >
          Contact Us
        </Link>
      </div>

      {/* Section 2 */}

      <div className="flex flex-col justify-around lg:flex-row items-center  px-6 py-16 md:px-8 lg:px-16 gap-10">
        <div className="flex flex-col items-start w-full lg:w-1/2">
          <img
            src={image1}
            alt="Illustration"
            className="max-w-xs md:max-w-sm"
            data-aos="fade-up"
            data-aos-delay="300"
          />
          <h1
            data-aos="fade-up"
            data-aos-delay="300"
            className="text-[#000] font-semibold text-xl md:text-2xl mt-5 w-full lg:w-[500px] xl:w-[554px]"
          >
            How can our ServiceNow Optimization Services help you?
          </h1>
          <ul
            className="mt-5 space-y-3"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            {[
              "Resolve technical debt",
              "Enhance integration capabilities",
              "Elevate the user experience",
              "Protect and optimize current enhancements and integrations",
              "Simplify future upgrades",
              "Improve platform performance and stability",
              "Accelerate adoption of new functionality",
            ].map((item, index) => (
              <li
                key={index}
                className="flex items-center gap-4 text-sm md:text-base"
              >
                <img src={tick} alt="Tick" className="w-5 h-5" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>

        <div
          className="flex justify-center lg:justify-end w-full lg:w-1/2"
          data-aos="fade-up"
          data-aos-delay="300"
        >
          <img
            className="w-48 h-48 md:w-56 md:h-56 lg:w-[480px] lg:h-[430px]"
            src={image}
            alt="Technical Illustration"
          />
        </div>
      </div>

      {/* Section 3 */}

      <div className="bg-[#FFFFFF] w-full py-8 md:py-16 mt-6">
        <div
          className="flex flex-col items-center text-center px-4 md:px-6"
          data-aos="fade-down-right"
        >
        
          <h1 className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 w-full md:w-2/3 lg:w-[879px]">
            Enable platform expansion through ServiceNow Optimization
          </h1>

          <Link
            data-aos="zoom-in"
            data-aos-delay="100"
            to={"/contact-us"}
            className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-bold 
                             hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                             text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
          >
            Contact us
          </Link>
        </div>
      </div>
    </>
  );
};

export default TechnicalConsultation;
